module.exports = __webpack_public_path__ + "img/avatar-4.11792f23.png";